import { motion } from "framer-motion";
import { Clock, Car, Backpack, Eye, MapPin } from "lucide-react";

const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=Unit%20E1%20MK45%204RP";

const items = [
  { icon: <Clock size={22} />, title: "Arrive 10 minutes early", desc: "Give yourselves time to change and settle in calmly — 10 minutes before class, or 15 for your very first visit. No rushing." },
  { icon: <Backpack size={22} />, title: "What to bring", desc: "Just swimwear and a towel. For little ones, a two-layer swim nappy with a neoprene outer — required until your child has been reliably toilet-trained (dry) for at least 6 months. Available at reception. No changing mat needed; we supply those." },
  { icon: <Car size={22} />, title: "Getting here", desc: "Unit E1, Barton-le-Clay, Bedfordshire, MK45 4RP — with parking close by.", link: MAPS_URL },
  { icon: <Eye size={22} />, title: "Awesome viewing", desc: "Our raised spectator platform gives parents and family a brilliant view of every splash and smile." },
];

export default function FirstVisit() {
  return (
    <section className="pb-24 md:pb-28" data-testid="first-visit-section">
      <div className="container mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-12">
          <span className="text-sm text-[#0EA5E9] tracking-[0.2em] uppercase font-bold">About your first visit</span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl font-bold tracking-tight text-[#0F172A] leading-tight">
            Everything you need for a calm first lesson
          </h2>
          <p className="mt-5 text-lg text-[#334155]">
            New to Happy Tiddlers? Here's how to make that first visit smooth and stress-free.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {items.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-white rounded-[2rem] p-8 border border-slate-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500"
              data-testid={`first-visit-${i}`}
            >
              <span className="grid place-items-center w-14 h-14 rounded-2xl mb-6 bg-[#0EA5E9] text-white">{it.icon}</span>
              <h3 className="font-heading text-lg font-semibold text-[#0F172A] leading-snug">{it.title}</h3>
              <p className="mt-3 text-[#334155] leading-relaxed">{it.desc}</p>
              {it.link && (
                <a
                  href={it.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-[#0EA5E9] hover:gap-2.5 transition-all"
                  data-testid="first-visit-map-link"
                >
                  <MapPin size={15} /> Open in Maps
                </a>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
